var React = require('react');

function CheckboxIcon (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.5 20.167l5.5 5.5L40.333 7.333","stroke":"currentColor","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M38.5 22v12.833a3.667 3.667 0 01-3.667 3.667H9.167A3.667 3.667 0 015.5 34.833V9.167A3.667 3.667 0 019.167 5.5h20.166","stroke":"currentColor","strokeWidth":"4","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckboxIcon.defaultProps = {"width":"44","height":"44","viewBox":"0 0 44 44","fill":"none"};

module.exports = CheckboxIcon;

CheckboxIcon.default = CheckboxIcon;
